// Use OR as prefix for all routes for Observational Research
// For any dynamic values in the route, use ##VALUE## as a placeholder which will be replaced by the actual value
// Note: Do not use these constants for API calls

import {
  CohortsFeaturePage,
  DataReliabilityPageTab,
  EvidencePlatformSidebarAppID,
  ProjectsSidebarAppFeatureId,
} from '@verantos-dev/core-enums';

import { PAGE_TABS_URL_PARAM } from './routingConstants';

// PROJECT ROUTE CONSTANTS
export const PROJECTS_BASE_PATH = EvidencePlatformSidebarAppID.projects;
export const COHORTS_PATH = ProjectsSidebarAppFeatureId.cohorts;
export const CONCEPT_GROUPS_BASE_PATH = EvidencePlatformSidebarAppID.conceptGroups;
export const COHORT_VERSION_PATH = 'cohort-version';
export const COHORT_BUILDER_PATH = CohortsFeaturePage.cohortBuilder;
export const DATA_RELIABILITY_PATH = ProjectsSidebarAppFeatureId.dataReliability;
export const ACCURACY_PATH = DataReliabilityPageTab.accuracy;
export const COMPLETENESS_PATH = DataReliabilityPageTab.completeness;
export const TRACEABILITY_PATH = DataReliabilityPageTab.traceability;

export const SUBJECT_URL_PARAM = 'subject';

// PROJECT ROUTE GETTERS
export const getProjectsBasePath = () => {
  return `/${PROJECTS_BASE_PATH}`;
};

export const getConceptGroupsBasePath = () => {
  return `/${CONCEPT_GROUPS_BASE_PATH}`;
};

// Cohort Getters
export const getCohortsPath = (activeProjectId: string) => {
  return `${getProjectsBasePath()}/${activeProjectId}/${COHORTS_PATH}`;
};
export const getCohortExportForAnalysisPath = (activeProjectId: string, activeCohortId: string) => {
  return `${getCohortsPath(activeProjectId)}/${activeCohortId}/export`;
};

// Cohort Builder Path Getters
export const getCohortBuilderPath = (
  activeProjectId: string,
  activeCohortId: string,
  latestVersionId: string
) => {
  return `${getCohortsPath(
    activeProjectId
  )}/${activeCohortId}/cohort-version/${latestVersionId}/${COHORT_BUILDER_PATH}`;
};

// Data Reliability Getters
export const getProjectDataReliabilityPath = (activeProjectId: string) => {
  return `${getProjectsBasePath()}/${activeProjectId}/${DATA_RELIABILITY_PATH}`;
};
export const getProjectAccuracyPath = (activeProjectId: string) => {
  return `${getProjectDataReliabilityPath(
    activeProjectId
  )}?${PAGE_TABS_URL_PARAM}=${ACCURACY_PATH}`;
};
export const getProjectCompletenessPath = (activeProjectId: string) => {
  return `${getProjectDataReliabilityPath(
    activeProjectId
  )}?${PAGE_TABS_URL_PARAM}=${COMPLETENESS_PATH}`;
};
export const getProjectTraceabilityPath = (activeProjectId: string) => {
  return `${getProjectDataReliabilityPath(
    activeProjectId
  )}?${PAGE_TABS_URL_PARAM}=${TRACEABILITY_PATH}`;
};
